import React from 'react';
import {View} from 'MWC';
import PropTypes from 'prop-types';
import tpl from '../templates/expressEnergy.jsx';
import {apiback} from '../../../../config';
import AExpressModel from '../../../Business/Models/aexpress.m';
import widgetsHelper from 'utils/getWidget.helper';

const frameOrigin = 'https://corploans.a-bank.com.ua';

export default class extends View {
    templates = {
        [this.uiStates.INITIAL]: <div />,
        [this.uiStates.INTERACTIVE]: tpl,
        [this.uiStates.ERROR]: tpl,
        [this.uiStates.STANDBY]: tpl
    };

    constructor(props) {
        super(props);

        this.state = {
            ui: this.uiStates.INITIAL,
            model: {},
            showModal: false,
            mode: 'express-energy-standard',
            where_by: ['path'],
            search_by: [location.pathname],
            widgets: [],
            loader: true
        };
        this.scrollTimers = [];
        this._initMethods();
        this.widgetsHelper = widgetsHelper;
        return this;
    }

    toggleMode(event) {
        const {mode} = event.detail;

        this.setState({mode});
        this.state.model.changeField('currentName', mode);
        if (mode === 'express-energy-collateral') {
            this.state.model.changeField('creditSum', '1000000');
            this.state.model.changeField('loanTerm', '30');
        }
    }

    componentWillReady(resolve) {
        resolve();
        this.scrollToSpecialOffer();
        document.addEventListener('switchCalcMode', this.toggleMode);
        this.widgetsHelper.getWidgets.call(this);
        fetch(apiback('EXPRESS_ENERGY_CALC'))
            .then(res => res.json())
            .then(json => {
                const list = Object.keys(json.data);
                const model = new AExpressModel(json.data, list, this.state.mode);

                this.setState({
                    model: model
                });
            })
            .then(this.scrollToCalc);
        // .catch(x => console.log('error:', x)); //todo добавить обработчик
    }

    componentWillUnmount() {
        document.removeEventListener('switchCalcMode', this.toggleMode);
        this.removeAnchorFromUrl();
        this.scrollTimers.forEach(timer => clearTimeout(timer));
    }

    scrollToSpecialOffer() {
        const params = new URLSearchParams(window.location.search);

        const waitForElement = id => {
            let attempts = 0;
            const maxAttempts = 50;
            const timeout = 300;

            const tryFind = () => {
                const element = document.getElementById(id);
                if (element) {
                    const timer = setTimeout(() => {
                        element.scrollIntoView({block: 'start', behavior: 'smooth'});
                    }, timeout);
                    this.scrollTimers.push(timer);
                } else if (attempts < maxAttempts) {
                    attempts++;
                    const timer = setTimeout(tryFind, timeout);
                    this.scrollTimers.push(timer);
                }
            };

            tryFind();
        };

        if (params.has('darexoffer')) {
            waitForElement('darexoffer');
        }
    }

    removeAnchorFromUrl() {
        const newUrl = window.location.pathname;
        window.history.replaceState({}, '', newUrl);
    }

    toggleModal() {
        this.setState({showModal: !this.state.showModal});
    }
    scrollToCalc = () => {
        const currentURL = window.location.href;
        const targetElement = document.querySelector('.credit-calculator');
        if (currentURL.includes('calc')) {
            targetElement.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
        }
    };

    _initMethods() {
        this.toggleModal = this.toggleModal.bind(this);
        this.toggleMode = this.toggleMode.bind(this);
    }

    static displayName = 'Business.Views.Aexpress';

    static contextTypes = {
        app: PropTypes.object
    };
}
